import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
    ButtonProps,
    ButtonRenderProps,
    ContentSection,
    createListTableColumns,
    Grid,
    GridColumn,
    GridRow,
    ListTable,
    renderName
} from "sprint-common-web";

import { getSystemPlatformDetailsDashboardHref } from "../../AdminRoutes";
import { AddSystemPlatformButton } from "./buttons/add/AddSystemPlatformButton";
import { RemoveSystemPlatformButton } from "./buttons/remove/RemoveSystemPlatformButton";
import { SystemPlatformListingContext } from "./context/SystemPlatformListingContext";
import { SystemPlatformListingItem } from "./SystemPlatformListingItem";
import { useSystemPlatformListingFilters } from "./useSystemPlatformListingFilters";

export const SystemPlatformListing: React.FC = () => {
    const { filters, setSort, setPage, setPageSize } = useSystemPlatformListingFilters();
    const { airlineId } = useParams<{ airlineId: string }>();
    const { systemPlatforms: items, isLoading, totalItems, load } = useContext(SystemPlatformListingContext);

    useEffect(() => {
        load(filters);
    }, [filters.sortBy, filters.sortOrder, totalItems]);

    const columns = createListTableColumns<SystemPlatformListingItem>([
        {
            type: "link",
            key: "systemName",
            name: "System",
            minWidth: 80,
            maxWidth: 240,
            isSortable: true,
            getHref: (item) => getSystemPlatformDetailsDashboardHref(airlineId, item.systemId)
        },
        {
            type: "basic",
            key: "integrator",
            name: "Integrator",
            minWidth: 80,
            maxWidth: 240,
            onRender: renderName
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 64,
            maxWidth: 64,
            buttons: [
                {
                    id: "remove",
                    render: RemoveSystemPlatformButton,
                    getItemId: (item) => item.systemId
                }
            ]
        }
    ]);

    const addSystemPlatformButtonProps: ButtonRenderProps<ButtonProps> = {
        render: AddSystemPlatformButton
    };

    return (
        <ContentSection header="System Platforms" buttons={[addSystemPlatformButtonProps]}>
            <Grid>
                <GridRow>
                    <GridColumn sm={12}>
                        <ListTable
                            columns={columns}
                            items={items}
                            pagination={{
                                page: filters.page,
                                pageSize: filters.pageSize,
                                totalItems,
                                onPageChange: setPage,
                                onPageSizeChange: setPageSize
                            }}
                            sort={{ by: filters.sortBy, order: filters.sortOrder }}
                            onSortChange={setSort}
                            isLoading={isLoading}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};
